import { lazy } from "react";
import { Outlet } from "react-router-dom";

//components imports
import PublicRoute from "./publicRoute";
import ROUTE_NAMES from "./routeNames";
import RoutesContainer from "components/routesContainer";
import PrivacyPolicy from "modules/cms/PrivacyPolicy";
import TermAndCondition from "modules/cms/TermAndCondition";

//pages import
const Login = RoutesContainer(lazy(() => import("modules/auth/login")));

// ==============================|| AUTHENTICATION ROUTING ||============================== //

const AuthenticationRoutes = {
  path: ROUTE_NAMES.BASE_ROUTE,
  element: <Outlet />,
  children: [
    {
      path: ROUTE_NAMES.BASE_ROUTE,
      element: (
        <PublicRoute>
          <Login />
        </PublicRoute>
      ),
    },
    {
      path: ROUTE_NAMES.MAIN_ROUTES.privacy_policy,
      element: (
        <PublicRoute>
          <PrivacyPolicy />
        </PublicRoute>
      ),
    },
    {
      path: ROUTE_NAMES.MAIN_ROUTES.term_condition,
      element: (
        <PublicRoute>
          <TermAndCondition />
        </PublicRoute>
      ),
    },
  ],
};

export default AuthenticationRoutes;
